import Stats from '../components/stats';
import { useTranslation } from 'react-i18next';
import HomePageSection from '../components/homePageSection';
import StepCard from '../components/stepCard';
import { ReactComponent as CreateAccountIcon } from "../img/icons/icon_create_account.svg";
import { ReactComponent as NewRequestIcon } from "../img/icons/icon_new_request.svg";
import { ReactComponent as ConeIcon } from "../img/icons/icon_cone.svg";
import { ReactComponent as SignIcon } from "../img/icons/icon_sign.svg";
import { ReactComponent as ArrowIcon } from "../img/icons/icon_arrow.svg";
import CloudBackgroundImg from "../img/home/clouds_background.png";
import PeopleMovingImg from "../img/home/people_moving.png";
import ConesRoadworkImg from "../img/home/cones_roadwork.png";
import parse from 'html-react-parser';
import { Button } from "@material-tailwind/react";
import { useTheme } from '../DarkThemeContext';
import { osiris_municipalities_url, signup_url_v2, osiris_type_requests_url } from '../data/navigationData';

const Home = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <div className="grid lg:grid-cols-[minmax(150px,16%)_auto] grid-cols-1 w-full">
      {/* First row with background (UNIQUEMENT cette section a le fond) */}
      <div className="col-span-3 grid lg:grid-cols-[minmax(150px,16%)_auto] grid-cols-1 gap-2 relative mt-0 flex">
        {/* Fond seulement pour cette row */}
        <div className="absolute inset-0 -z-10 h-full">
          <img 
            src={CloudBackgroundImg} 
            alt="Background" 
            className="w-full h-full object-cover"
          />
          <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent dark:from-blue-800"></div>
        </div>
        
        {/* First column (16% width on desktop, full width on mobile) */}
        <div className="flex items-center justify-center px-4 relative z-30 py-4 lg:py-0">
          <div className="relative transform -rotate-3 bg-white dark:bg-blue-700 dark:text-white rounded-3xl shadow-lg p-4 lg:p-6 inline-block max-w-full lg:w-auto mx-auto font-bold text-lg lg:text-xl text-left text-blue-600 break-words">
            {parse(t('home-page-occupation-needed-text'))}

            <div className="absolute -bottom-10 -right-8 lg:-right-16 z-50">
              <ArrowIcon className="w-20 h-20 lg:w-32 lg:h-32 text-blue-600 drop-shadow-lg" />
            </div>
          </div>
        </div>

      {/* Rectangles bleus regroupés horizontalement sur mobile - déplacés juste après le rectangle blanc */}
      <div className="col-span-3 flex lg:hidden flex-row flex-wrap justify-center gap-2 px-4 z-20 pb-4">
        <div className="transform -rotate-2 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-3 w-auto font-bold text-sm text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-move')}
        </div>
        <div className="transform rotate-6 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-3 w-auto font-bold text-sm text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-parking')}
        </div>
        <div className="transform -rotate-4 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-3 w-auto font-bold text-sm text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-container')}
        </div>
        <div className="transform -rotate-6 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-3 w-auto font-bold text-sm text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-scaffolding')}
        </div>
        <div className="transform rotate-4 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-3 w-auto font-bold text-sm text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-roadwork')}
        </div>
      </div>

        <div className="flex flex-col lg:flex-row items-stretch lg:justify-between px-4 lg:pl-16 lg:pr-16 py-4 lg:py-0">
          <div className="flex-1 flex flex-col justify-between w-full mb-4 lg:mb-0">
            <div className="flex-1 flex items-center justify-center lg:justify-start">
              <div className="font-bold text-2xl lg:text-3xl text-center lg:text-left text-blue-900 dark:text-white">
                {parse(t('home-page-title'))}
              </div>
            </div>
            {/* "How does it work" - Desktop */}
            <div className="font-bold text-xl lg:text-3xl text-center lg:text-left text-blue-700 dark:text-yellow-700 mt-2 lg:mt-8 lg:flex hidden">
              {t('how-does-it-work')}
            </div>
          </div>

          {/* Signup button - Desktop*/}
          <div className="flex flex-col items-center lg:items-end mb-4 lg:mb-0 lg:flex justify-end items-end hidden">
            <a href={signup_url_v2} target="_blank" rel="noreferrer">
              <Button variant="filled" color={theme === "dark" ? "white" : "blue"} size="sm" className="dark:text-blue-900 text-xl dark:hover:bg-blue-gray-50 dark:focus:bg-blue-gray-50">
                {t('signup')}
              </Button>
            </a>
          </div>

          <div className="lg:ml-4 w-full lg:w-auto lg:flex justify-center hidden">
            <img src={PeopleMovingImg} alt="People Moving" className="w-3/4 lg:w-full h-auto object-contain"/>
          </div>
        </div>
      </div>
  
     
      {/* Signup button - Mobile*/}
      <div className="col-span-3 flex flex-col items-center lg:hidden mb-6">
        <a href={signup_url_v2} target="_blank" rel="noreferrer">
          <Button variant="filled" color={theme === "dark" ? "white" : "blue"} size="sm" className="dark:text-blue-900 text-xl dark:hover:bg-blue-gray-50 dark:focus:bg-blue-gray-50">
            {t('signup')}
          </Button>
        </a>
      </div>

      {/* "How does it work" - Mobile */}
      <div className="col-span-3 flex items-center justify-center lg:hidden px-4 mb-4">
        <div className="font-bold text-xl text-center text-blue-700 dark:text-yellow-700 w-full">
          {t('how-does-it-work')}
        </div>
      </div>
  
      {/* Version desktop des rectangles bleus */}
      <div className="col-span-3 lg:col-span-1 hidden lg:flex lg:flex-col flex-row flex-wrap justify-start gap-3 px-4 lg:pl-4 z-20 lg:pb-28">
        <div className="transform -rotate-2 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-4 max-w-md mx-auto font-bold text-lg text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-move')}
        </div>
        <div className="transform rotate-6 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-4 max-w-md mx-auto font-bold text-lg text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-parking')}
        </div>
        <div className="transform -rotate-4 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-4 max-w-md mx-auto font-bold text-lg text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-container')}
        </div>
        <div className="transform -rotate-6 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-4 max-w-md mx-auto font-bold text-lg text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-scaffolding')}
        </div>
        <div className="transform rotate-4 bg-blue-50 dark:bg-blue-600 dark:text-white rounded-lg shadow-lg p-4 max-w-md mx-auto font-bold text-lg text-left text-blue-600 border border-blue-200">
          {t('home-page-occupation-needed-roadwork')}
        </div>
      </div>
  
      <div className="col-span-3 lg:col-span-2 row-span-1 flex items-start justify-center">
        <div className="container mx-auto px-4 py-8">
          <div className="flex flex-col lg:flex-row items-center lg:items-start justify-center lg:justify-start gap-8 lg:gap-16 lg:pl-16">
            <div className="relative rounded-lg p-4 lg:p-6 bg-blue-40 dark:bg-blue-900 bg-opacity-50 inline-block w-full lg:w-auto">
              <svg className="absolute inset-0 w-full h-full rounded-lg" xmlns="http://www.w3.org/2000/svg">
                <rect width="100%" height="100%" fill="none" stroke="#075985" strokeWidth="2" 
                      strokeDasharray="8,8" rx="8" />
              </svg>
              <h2 className="text-center text-gray-600 dark:text-white text-xl mb-6 underline">
                {t('how-does-it-work-on-osiris')}
              </h2>
              <div className="flex flex-col md:flex-row items-center lg:items-start gap-6">
                <StepCard
                  displayedNumber="1"
                  icon={<CreateAccountIcon className="w-15 h-15" />}
                  text={t('how-does-it-work-stepcard-1-text')}
                  textHover={t('how-does-it-work-stepcard-1-text-hover')}
                  link={signup_url_v2}
                  linkText={t('how-does-it-work-stepcard-1-link')}
                  theme="blue"
                />
                <StepCard
                  displayedNumber={2}
                  icon={<NewRequestIcon className="w-15 h-15" />}
                  text={t('how-does-it-work-stepcard-2-text')}
                  textHover={t('how-does-it-work-stepcard-2-text-hover')}
                  link={osiris_type_requests_url}
                  linkText={t('how-does-it-work-stepcard-2-link')}
                  theme="blue"
                />
                <StepCard
                  displayedNumber={3}
                  icon={<ConeIcon className="w-15 h-15" />}
                  text={t('how-does-it-work-stepcard-3-text')}
                  textHover={t('how-does-it-work-stepcard-3-text-hover')}
                  link={osiris_type_requests_url}
                  linkText={t('how-does-it-work-stepcard-3-link')}
                  theme="blue"
                />
              </div>
            </div>
  
            <div className="flex flex-col items-center mt-8 lg:mt-0">
              <h2 className="text-center text-gray-600 dark:text-white text-xl mb-6 underline pt-0 lg:pt-6">
                {t('how-does-it-work-on-municipality')}
              </h2>
              <StepCard
                displayedNumber={null}
                icon={<SignIcon className="w-15 h-15" />}
                text={t('how-does-it-work-stepcard-4-text')}
                textHover={t('how-does-it-work-stepcard-4-text-hover')}
                link={osiris_municipalities_url}
                linkText={t('how-does-it-work-stepcard-4-link')}
                theme="white"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Signup button - Mobile*/}
      <div className="col-span-3 flex flex-col items-center lg:hidden mb-6">
        <a href={signup_url_v2} target="_blank" rel="noreferrer">
          <Button variant="filled" color={theme === "dark" ? "white" : "blue"} size="sm" className="dark:text-blue-900 text-xl dark:hover:bg-blue-gray-50 dark:focus:bg-blue-gray-50">
            {t('signup')}
          </Button>
        </a>
      </div>
  
      <div className="bg-blue-40 dark:bg-blue-600 col-span-3 lg:col-span-1 row-span-1 flex items-center justify-center"></div>
  
      <div className="col-span-3 lg:col-span-2 row-span-1 flex">
        <div className="bg-blue-40 dark:bg-blue-600 px-4 lg:pl-16 w-full flex items-center">  
          <HomePageSection
            title={t('what-is-osiris-section-title')}
            subtitle={t('what-is-osiris-section-subtitle')}
            content={t('what-is-osiris-section-content')}
          />
          
          <div className="w-full lg:w-auto lg:flex justify-center hidden">
            <img src={ConesRoadworkImg} alt="Cones roadwork" className="w-3/4 lg:w-full h-auto object-contain"/>
          </div>
        </div>
      </div>
  
      <div className="col-span-3 row-span-1 flex items-center justify-center">
        <Stats />
      </div>
    </div>
  );
}

export default Home;